import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 24 24",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M6.333 22h11.334c2.4 0 4.333-1.933 4.333-4.333V6.333C22 3.933 20.067 2 17.667 2H6.333A4.325 4.325 0 0 0 2 6.333v11.334C2 20.067 3.933 22 6.333 22Zm12.913-10.884c0-3.267-3.266-5.917-7.283-5.917S4.68 7.85 4.68 11.116c0 2.917 2.583 5.367 6.083 5.833.233.05.567.15.633.367.067.183.05.467.017.667l-.1.616-.003.014c-.036.196-.128.695.636.386.784-.333 4.2-2.466 5.717-4.233 1.083-1.167 1.583-2.35 1.583-3.65Zm-2.305-.934c0 .084-.05.15-.134.15h-1.383v.517h1.383c.067 0 .134.067.134.15v.517c0 .083-.05.15-.134.15h-1.383v.466h1.383c.067 0 .134.067.134.15v.517c0 .083-.05.15-.134.15h-2.033a.237.237 0 0 1-.1-.033.236.236 0 0 1-.033-.1V9.649c0-.033.016-.067.033-.1a.237.237 0 0 1 .1-.033h2.033c.067 0 .134.066.134.15v.516Zm-7.698 2.016H7.86V9.68a.15.15 0 0 0-.15-.15h-.517a.15.15 0 0 0-.15.15v3.167c0 .033.017.067.033.1a.237.237 0 0 0 .1.033H9.21c.083 0 .133-.066.133-.15v-.516c.05-.05-.017-.117-.1-.117Zm1.234-2.65h-.516c-.084 0-.15.067-.15.134v3.167c0 .083.066.133.15.133h.516c.084 0 .15-.066.15-.133V9.682c0-.067-.066-.133-.15-.133Zm3.017 0h.5c.084 0 .15.067.15.134v3.167c0 .066-.066.133-.15.133h-.516c-.01 0-.014-.006-.02-.015a.092.092 0 0 0-.014-.018l-1.45-1.967v1.884c0 .066-.066.133-.15.133h-.516c-.084 0-.15-.05-.15-.133V9.699c0-.067.066-.133.15-.133h.533l.017.016c.016 0 .016.017.016.017l1.45 1.966V9.683c0-.067.067-.133.15-.133Z",
          "clip-rule": "evenodd",
        }),
      ]
    )
  );
}
